import React from "react"
import HomeConsultationFormStyle from "./HomeConsultationFormStyle.module.styl"

const HomeConsultationForm = ({
  handleEmailChange,
  email,
  name,
  handleSubmit,
  path,
  handleNameChange,
  errors,
}) => {
  return (
    <form className={HomeConsultationFormStyle.holder}>
      <input
        type="text"
        onChange={handleNameChange}
        name="FNAME"
        placeholder="Твоето име"
        value={name}
        className={HomeConsultationFormStyle.input}
      />
      <span className="home_consultation_error">
        {" "}
        {errors.name && errors.name}
      </span>
      <input
        type="text"
        value={email}
        placeholder="Email"
        name="EMAIL"
        onChange={handleEmailChange}
        className={HomeConsultationFormStyle.input}
      />
      <span className="home_consultation_error">
        {" "}
        {errors.email && errors.email}
      </span>
      <input type="hidden" name="URL" value={path} />
      <button
        className={HomeConsultationFormStyle.button}
        onClick={handleSubmit}
      >
        Запиши ме!
      </button>
    </form>
  )
}

export default HomeConsultationForm
